export function limpa_cpf_cnpj(cpf_cnpj: string){
    return cpf_cnpj.replaceAll(".","").replaceAll("-","").replaceAll("/","").replaceAll(" ","")
}